import { render } from "./MyQuestionsMain.vue?vue&type=template&id=c47f3d5c&scoped=true"
import script from "./MyQuestionsMain.vue?vue&type=script&lang=js"
export * from "./MyQuestionsMain.vue?vue&type=script&lang=js"

import "./MyQuestionsMain.vue?vue&type=style&index=0&id=c47f3d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47f3d5c"]])

export default __exports__